define('SuiteDynamics.PLPPromoBanner.Entrypoint',
	[
		'SuiteDynamics.PLPPromoBanner.ItemCellPromoBanner'
	],
	function (
		ItemCellPromoBanner
	)
{
	'use strict';

	return {
		mountToApp: function(container) {
			ItemCellPromoBanner.mountToApp(container);
		}
	}
});
